import { render, staticRenderFns } from "./BoolSubtractIcon.vue?vue&type=template&id=7347fef4&"
import script from "./BoolSubtractIcon.vue?vue&type=script&lang=js&"
export * from "./BoolSubtractIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports